import { useQuery } from '@tanstack/react-query';

import { sanitizeReservationParams } from '../../shared/helpers';
import { useApi } from '../../shared/providers/api.provider';
import { Reservation, RESERVATION_STATUS } from '../../shared/types';

interface UseGetReservationParams {
  restaurantId?: string;
  reservationId?: string;
  secret?: string;
}

const POLLING_INTERVAL = 5000;

export const FETCH_RESERVATION_CACHE_KEY = 'reservation';

export const getReservationQueryKey = ({
  restaurantId,
  reservationId,
  secret,
}: UseGetReservationParams) => [FETCH_RESERVATION_CACHE_KEY, restaurantId, reservationId, secret];

export const useGetReservation = ({
  restaurantId,
  reservationId,
  secret,
}: UseGetReservationParams) => {
  const api = useApi();

  return useQuery<Reservation>({
    queryKey: getReservationQueryKey({ restaurantId, reservationId, secret }),
    queryFn: async () => {
      const params = sanitizeReservationParams({ restaurantId, reservationId, secret });

      const { data } = await api.get<Reservation>(
        `/restaurants/${params.restaurantId}/reservations/${params.reservationId}`,
        {
          params: { secret: params.secret },
        },
      );
      return data;
    },
    enabled: !!restaurantId && !!reservationId && !!secret,
    refetchInterval: (query) =>
      query.state.data?.status === RESERVATION_STATUS.PENDING ? POLLING_INTERVAL : false,
    refetchIntervalInBackground: false,
  });
};
